// removed by extract-text-webpack-plugin
module.exports = {"container":"_3p5re","supporters-container":"KM65o","supporter-avatar-container":"Yxbyx","supporter-avatar":"_23Bjf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SupportersAvatar/SupportersAvatar.scss
// module id = ./src/components/SupportersAvatar/SupportersAvatar.scss
// module chunks = 5